import { Component, DestroyRef, ElementRef, inject, OnDestroy, ViewChild } from '@angular/core';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { LoadingService } from '../../services/loading.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Offcanvas } from 'bootstrap';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Select2, Select2Data } from 'ng-select2-component';
import { NgSelectModule } from '@ng-select/ng-select';
import { debounceTime, distinctUntilChanged, Subscription, switchMap } from 'rxjs';
import { HttpServiceService } from '../../services/http-service.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { UserInfo } from '../../models/users.model';
import { USER_PERMISSIONS, APP_CONSTANTS } from '../../app.constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-properties-list',
  imports: [
    BreadcrumbComponent,
    NgFor,
    NgIf,
    PaginationComponent,
    ReactiveFormsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatFormFieldModule,
    RouterModule,
    Select2,
    NgClass,
    NgSelectModule
  ],
  templateUrl: './properties-list.component.html',
  styleUrl: './properties-list.component.css',
  providers: [provideNativeDateAdapter()],
})
export class PropertiesListComponent implements OnDestroy {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Properties',
    breadcrumb_url : '/admin'
  }
  page: any = 1;
  offset_limit : number = 20;
  totalRows: number = 3;
  totalPage: any = 0;
  boxActive: Boolean = false;
  orderData : any = [];
  allData : any = [];
  propertyadd_edit :  boolean = false;
  loadingService = inject(LoadingService);
  propertyForm! : FormGroup;
  advancedSearchForm! : FormGroup;
  searchForm!: FormGroup;
  @ViewChild('addPropertyButton') offcanvas!: ElementRef;
  private offcanvasInstance: Offcanvas | null = null;
  @ViewChild('advancedSearchPopup') searchcanvas!: ElementRef;
  private searchInstance: Offcanvas | null = null;
  propertyadvanced_search: boolean = false;
  private getAllUsersSubscription! :  Subscription;
  private getCountriesSubscription? : Subscription;
  private getStatesSubscription?: Subscription;
  private getCitiesSubscription?: Subscription;
  private addPropertySubscription?: Subscription;
  valueSet: any = 'Select Status';
  users: Select2Data = [];
  countries : Select2Data = [];
  states : Select2Data = [];
  cities : Select2Data = [];
  selected_country : string | undefined = '';
  selected_state : string | undefined = '';
  selected_city : string | undefined = '';
  cities_list: Select2Data = [];
  private getAllPropertiesSubscription? : Subscription;
  private authService = inject(LocalStorageService);
  userInfo? : UserInfo;
  disableClear : boolean = false;
  pageCount : number = 1;
  queryParamsSubsscription?: Subscription;
  isQueryParamsExists : boolean = false;
  restoreFormObj : any;
  quickStatsOpen : boolean = false;
  private destroyRef = inject(DestroyRef);

  categoryOptions = [
    { value: 'End-to-End Management', label: 'End-to-End Management' },
    { value: 'Sale', label: 'Sale' },
    { value: 'Property Management', label: 'Property Management' },
    { value: 'Tenant Placement', label: 'Tenant Placement' },
    { value: 'Plot Monitoring', label: 'Plot Monitoring' },
    { value: 'Repairs & Renovation', label: 'Repairs & Renovation' },
    { value: 'Documentation', label: 'Documentation' }
  ];

  countByCategory: { [key: string]: number } = {};
  countByStatus: { [key: string]: number } = {};

  // Order + colour scheme drives the summary-card row below the search row.
  statusCards: { key: string; label: string; bgClass: string }[] = [
    { key: 'Approved', label: 'Approved', bgClass: 'bg-success text-white' },
    { key: 'Work in Progress', label: 'Work in Progress', bgClass: 'bg-info text-white' },
    { key: 'Pending', label: 'Pending', bgClass: 'bg-warning text-dark' },
    { key: 'Enquiry', label: 'Enquiry', bgClass: 'bg-primary text-white' },
    { key: 'Archived', label: 'Archived', bgClass: 'bg-secondary text-white' }
  ];

  categoryCards: { key: string; label: string; bgClass: string }[] = [
    { key: 'End-to-End Management', label: 'End-to-End Management', bgClass: 'bg-info text-white' },
    { key: 'Sale', label: 'Sale', bgClass: 'bg-primary text-white' },
    { key: 'Property Management', label: 'Property Management', bgClass: 'bg-success text-white' },
    { key: 'Tenant Placement', label: 'Tenant Placement', bgClass: 'bg-warning text-dark' },
    { key: 'Plot Monitoring', label: 'Plot Monitoring', bgClass: 'bg-danger text-white' },
    { key: 'Repairs & Renovation', label: 'Repairs & Renovation', bgClass: 'bg-secondary text-white' },
    { key: 'Documentation', label: 'Documentation', bgClass: 'bg-dark text-white' }
  ];

  listingStatusOptions = [
    { value: 'Sell', label: 'Sell' },
    { value: 'Sold', label: 'Sold' },
    { value: 'Rent Available', label: 'Rent Available' },
    { value: 'Rent Occupied', label: 'Rent Occupied' },
    { value: 'Property Management', label: 'Property Management' },
    { value: 'Tenant Placement', label: 'Tenant Placement' },
    { value: 'Plot Monitoring', label: 'Plot Monitoring' },
    { value: 'Repairs & Renovation', label: 'Repairs & Renovation' },
    { value: 'Documentation', label: 'Documentation' }
  ];

  constructor(private fb: FormBuilder, private httpService : HttpServiceService, private route: ActivatedRoute, private alertService: NgxToastrService, private router : Router){
    //this.orderData = this.propertiesList.slice();
    this.propertyForm = this.fb.group({
      name: ['', [Validators.required]],
      type: ['', [Validators.required]],
      address_1 : ['', [Validators.required]],
      address_2 : [''],
      country : ['', [Validators.required]],
      state : ['', [Validators.required]],
      city : ['', [Validators.required]],
      locality : ['',[Validators.required]],
      postal_code : ['', [Validators.required, Validators.pattern('^[0-9]{5,10}$')]],
      listing_status : ['', [Validators.required]],
      // cover_image : [null],
      description : ['', [Validators.required, Validators.minLength(15)]]
    });
    this.advancedSearchForm = this.fb.group({
      budget_min: [''],
      budget_max: [''],
      rental_agreement_end_date_start : [''],
      rental_agreement_end_date_end : [''],
      owner_agreement_start_from : [''],
      owner_agreement_start_to : ['']
    });
    this.searchForm = this.fb.group({
      name: [''],
      managed_by: [''],
      city: [''],
      status: [''],
      category: [[]],
      listing_status: ['']
    })
    

  }

  ngOnInit(): void {
    this.advancedSearchForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.checkMinMax();
    });

    this.searchForm.get('name')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => {
        if(!this.isQueryParamsExists) this.handleSearch(value);
        this.isQueryParamsExists = false;
      });

      this.propertyForm.get('country')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
        const selected = this.countries.find((opt:any) => opt.value == id);
        this.selected_country = selected?.label;
      });

      this.propertyForm.get('state')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
        const selected = this.states.find((opt:any) => opt.value == id);
        this.selected_state = selected?.label;
      });

      this.propertyForm.get('city')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(id => {
        const selected = this.cities.find((opt:any) => opt.value == id);
        this.selected_city = selected?.label;
      });
    let cities = this.route.snapshot.data['data']?.["data"] ?? [];
    for (let city of cities) {
      this.cities_list.push(
        {
          value: city,
          label: city,
          data: { name: city }
        }
      )
    }
    // this.getAllProperties();
    if(this.checkPropertyManagedByFilter) this.getAllUsers();
    this.userInfo = this.authService.getItem("userInfo") as UserInfo;
    this.queryParamsSubsscription = this.route.queryParams.subscribe((data: any) => {
      let resp = { ...data };
      if(resp.page){
         this.page = parseInt(resp.page);
         delete resp.page;
         const hasAnyValue = Object.values(resp).some(value => !!value);
         if(hasAnyValue){
          this.restoreFormObj = { ...resp };
          this.isQueryParamsExists = true;
         }
        this.handleSearch('', "keepPage", resp , 'onload');
      }else{
        this.resetSearchForm();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const offcanvasElement = this.offcanvas?.nativeElement;
      if (offcanvasElement) {
        this.offcanvasInstance = Offcanvas.getOrCreateInstance(offcanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }

      const searchCanvasElement = this.searchcanvas?.nativeElement;
      if (searchCanvasElement) {
        this.searchInstance = Offcanvas.getOrCreateInstance(searchCanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }

    });
  }

  moveToBills(propertyId : string, activeId : number){
    this.router.navigate(['admin', 'properties', 'property-view', propertyId, activeId]);
  }
  

  getAllProperties(query : any = '', type : string = ''){
    this.getAllPropertiesSubscription = this.httpService.getAllProperties(this.page, this.offset_limit, query).subscribe({
      next : (response) => {
        this.orderData = response['data']?.["properties"];
        if(this.orderData.length == 1){
          let uid = this.orderData[0]?.["uid"];
          if(uid && type && !query) {
            this.viewProperty(uid, 1);
            return;
          }
        }
        this.totalRows = this.offset_limit;
        this.allData = this.paginator(this.orderData, this.page, this.totalRows, response['data']?.["total"]);
        this.totalPage = response.data.total;
        this.pageCount = response.data.pageCount;
        this.countByCategory = response.data.count_by_category ?? {};
        this.countByStatus = response.data.count_by_status ?? {};
        if(this.propertyadvanced_search) this.advancedPropertyClose();
      }
    })
  }

  private toIsoDate(d: Date): string {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getCategoryCountEntries(): { key: string; value: number }[] {
    return Object.entries(this.countByCategory)
      .filter(([key]) => key && key !== 'unknown')
      .map(([key, value]) => ({ key, value }));
  }

  getStatusCount(status: string): number {
    return this.countByStatus[status] ?? 0;
  }

  onStatusCardClick(status: string): void {
    const current = this.searchForm.get('status')?.value;
    // Toggle off when the user clicks the same card again so they can return
    // to the unfiltered view without hunting for the Clear button.
    const next = current === status ? '' : status;
    this.searchForm.patchValue({ status: next });
    this.handleSearch('');
  }

  getCategoryCount(category: string): number {
    return this.countByCategory[category] ?? 0;
  }

  isCategorySelected(category: string): boolean {
    const value = this.searchForm.get('category')?.value;
    return Array.isArray(value) && value.includes(category);
  }

  onCategoryCardClick(category: string): void {
    const value = this.searchForm.get('category')?.value;
    const list: string[] = Array.isArray(value) ? [...value] : [];
    const i = list.indexOf(category);
    if (i >= 0) list.splice(i, 1);
    else list.push(category);
    this.searchForm.patchValue({ category: list });
    this.handleSearch('');
  }

  deleteProperty(propertyId : string){

  }

  handleSearch(value : any, keepPage : string = '', data : any = '' , type : string = ''){
    const searchData = data ? data : this.searchForm.value;
    let query = '';
    for(let key in searchData){
        const raw = searchData[key];
        const v = Array.isArray(raw) ? raw.join(',') : raw;
        if(v){
           query+=`&${key}=${encodeURIComponent(v)}`;
        }
    }
    if(!keepPage) this.page = 1;
    if(query || !value) {
      this.getAllProperties(query, type);
      this.disableClear = (value || query) ? true : false;
    }

  }

  advancedSearch(){
    let advancedSearchData = this.advancedSearchForm.value;
    let obj = {
       ...this.searchForm.value,
       ...advancedSearchData
    };
    let query = '';
    for(let key in obj){
        const raw = obj[key];
        let v: any;
        if (Array.isArray(raw)) v = raw.join(',');
        else if (raw instanceof Date) v = this.toIsoDate(raw);
        else v = raw;
        if(v){
           query+=`&${key}=${encodeURIComponent(v)}`;
        }
    }
    this.page = 1;
    this.disableClear = true;
    this.getAllProperties(query);
  }

  resetSearchForm(){
    this.page = 1;
    this.searchForm.reset({
      category: [],
      status : '',
      listing_status: ''
    }, { emitEvent: false });
    this.getAllProperties();
    this.disableClear = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
    this.isQueryParamsExists = false;
  }

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    // Always the first page of managers: `this.page` is the property list page.
    this.getAllUsersSubscription = this.httpService.getAllUsers(1, 200, query).subscribe({
      next : (response) => {
        for(let user of response.data.users){
            this.users.push(
              {
                value: user.uid,
                label: user.first_name + user.last_name,
                data: { name: user.first_name + user.last_name }
              }
            )
        }
        if(this.isQueryParamsExists) {
           const restore = { ...this.restoreFormObj };
           if (typeof restore.category === 'string') {
             restore.category = restore.category.split(',').filter(Boolean);
           }
           this.searchForm.patchValue(restore);
        }
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

  getCountries(){
    this.getCountriesSubscription = this.httpService.getLocations('country').subscribe({
      next : (resp) => {
        for(let country of resp.data){
          this.countries.push(
            {
              value: country.id,
              label: country.name,
              data: { name: country.name }
            }
          )
      }
      },
      error : (error) => {

      }
    });
  }

  getStates(){
    let countryId = this.propertyForm?.get('country')?.value;
    if(countryId){
      this.states = [];
      this.getStatesSubscription = this.httpService.getLocations('state','&countryId='+countryId).subscribe({
        next : (resp) => {
          for(let state of resp.data){
            this.states.push(
              {
                value: state.id,
                label: state.name,
                data: { name: state.name }
              }
            )
        }
        },
        error : (error) => {

        }
      });
    }
  }

  getCities(){
    let stateId = this.propertyForm?.get('state')?.value;
    if(stateId){
      this.cities = [];
      this.getCitiesSubscription = this.httpService.getLocations('city','&stateId='+stateId).subscribe({
        next : (resp) => {
          for(let city of resp.data){
            this.cities.push(
              {
                value: city.id,
                label: city.name,
                data: { name: city.name }
              }
            )
        }
        },
        error : (error) => {

        }
      });
    }
  }



  checkMinMax() {
    let { budget_min, budget_max } = this.advancedSearchForm?.value;
    // Prevent min from exceeding max
    if (budget_max && parseInt(budget_min) > parseInt(budget_max)) {
      this.advancedSearchForm.controls['budget_max'].setErrors({ minGreaterThanMax: true });
    }else {
      this.advancedSearchForm.controls['budget_max'].setErrors(null);
    }
  }

  onImageChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
      };
      reader.readAsDataURL(file);

      // this.propertyForm.patchValue({ cover_image: file });
      // this.propertyForm.get('cover_image')?.updateValueAndValidity();
    }
  }

  addPropertyEvent(e : any){
    this.addPropertyToggle();
    if (this.offcanvasInstance) {
      this.offcanvasInstance.show();
    }
  }

  addPropertyToggle(){
    this.propertyadd_edit = !this.propertyadd_edit;
    if(this.propertyadd_edit){
      this.getCountries();
    }
  }

  propertyClose(){
    this.addPropertyToggle();
    if (this.offcanvasInstance) {
      this.propertyForm.reset();
      this.offcanvasInstance.hide();
    }
  }

  onSubmit(){
    if(this.propertyForm.valid){
      const formData = new FormData();
      Object.keys(this.propertyForm.controls).forEach((key) => {
        let value = '';
        if(key == 'country'){
          value = this.selected_country ?? "";
        }else if(key == 'state'){
          value = this.selected_state ?? "";
        }else if(key == 'city'){
          value = this.selected_city ?? "";
        }
        formData.append(key, value ? value : this.propertyForm.get(key)?.value);
      });
      this.addPropertySubscription = this.httpService.addProperty(formData).subscribe({
        next : (response) => {
          this.getAllProperties();
          this.propertyClose();
          this.propertyForm.reset();
          this.searchForm.reset();
          this.alertService.success(response.message, "toast-top-right");
        }
      })
    }
  }

  viewProperty(uid : string, tab : number){
    let data = {
      ...this.searchForm.value,
      page : this.page
    };
    this.router.navigate(['/admin/properties/property-view', uid, 1], {
      queryParams: data
    });
  }

  pageChange(e: any) {    //  Page Change funcation   ---------
    if(this.page == e) return;
    this.page = e;
    this.handleSearch('', 'keepPage');
    // this.allData = this.paginator(this.orderData, this.page, this.totalRows);
    // this.totalPage = this.allData.total_pages;
  }

  paginator(items: any, current_page: any, per_page_items: any, total_records : any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);

    return {
      page: page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: items.length,
      total_pages: total_pages,
      data: paginatedItems,
      startPage : offset + 1,
      endPage : page * per_page,
    };
  }

  checkUncheckAll() {
    if (this.boxActive) {
      this.boxActive = false;
    } else {
      this.boxActive = true;
    }
  }

  quickStatsToggle(){
    this.quickStatsOpen = !this.quickStatsOpen;
  }

  addPropertySearchToggle(){
    this.propertyadvanced_search = !this.propertyadvanced_search;
    if (this.searchInstance && this.propertyadvanced_search) {
      this.searchInstance.show();
    }
  }

  advancedPropertyClose(){
    this.addPropertySearchToggle();
    if (this.searchInstance) {
      this.searchInstance.hide();
      this.advancedSearchForm.reset();
    }
  }

  get displayManagedBy(){
    if(this.userInfo?.["role_identifier"] == "partner_admin" || this.userInfo?.["role_identifier"] == "super_admin"){
      return true;
    }
    return false;
  }

  ngOnDestroy(){
    this.getAllUsersSubscription?.unsubscribe();
    this.getCountriesSubscription?.unsubscribe();
    this.getStatesSubscription?.unsubscribe();
    this.getCitiesSubscription?.unsubscribe();
    this.getAllPropertiesSubscription?.unsubscribe();
    this.addPropertySubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
  }

  get checkPropertyAdd() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_ADD);
  }

  get checkPropertyView() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_VIEW);
  }

  get checkPropertyDetailsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_DETAILS_TAB);
  }

  get checkPropertyDocumentsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_DOCUMENTS_TAB);
  }

  get checkPropertyBillsTab() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_BILLS_TAB);
  }

  get showMore(){
    return (this.checkPropertyDetailsTab || this.checkPropertyDocumentsTab || this.checkPropertyBillsTab);
  }

  get checkPropertyManagedByFilter() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_MANAGED_BY_FILTER);
  }

}
